import React, { useState, useEffect } from 'react';
import { getAgents } from '../../../services/mysteryShopService';
import type { MysteryShopAgent } from '../../../types/mysteryShop';
import { getScoreColor } from '../utils';

interface AllAgentsProps {
  onSelectAgent: (id: string) => void;
}

export const AllAgents: React.FC<AllAgentsProps> = ({ onSelectAgent }) => {
  const [agents, setAgents] = useState<MysteryShopAgent[]>([]);
  const [rev, setRev] = useState(0);

  useEffect(() => {
    getAgents().then(setAgents);
  }, [rev]);

  return (
    <div className="space-y-6">
      <div className="flex items-start justify-between">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Leasing Agents</h1>
          <p className="text-gray-500 mt-1">{agents.length} agents tracked</p>
        </div>
        <button
          onClick={() => setRev(r => r + 1)}
          className="p-2 text-gray-400 hover:text-gray-700 rounded-lg hover:bg-gray-100 transition-colors"
          title="Refresh"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M21 2v6h-6"/>
            <path d="M3 12a9 9 0 0 1 15-6.7L21 8"/>
            <path d="M3 22v-6h6"/>
            <path d="M21 12a9 9 0 0 1-15 6.7L3 16"/>
          </svg>
        </button>
      </div>

      <div className="bg-white rounded-xl shadow-sm border border-gray-100">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b border-gray-100">
                <th className="px-5 py-4">Agent</th>
                <th className="px-5 py-4 text-center">Properties</th>
                <th className="px-5 py-4 text-center">Calls</th>
                <th className="px-5 py-4 text-center">Avg Score</th>
                <th className="px-5 py-4 text-center">Tour Rate</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-50">
              {agents.map(agent => (
                <tr
                  key={agent.id}
                  className="hover:bg-gray-50 cursor-pointer transition-colors"
                  onClick={() => onSelectAgent(agent.id)}
                >
                  <td className="px-5 py-4">
                    <p className="font-medium text-gray-800">{agent.name}</p>
                  </td>
                  <td className="px-5 py-4 text-center text-gray-600">{agent.propertyCount ?? 0}</td>
                  <td className="px-5 py-4 text-center text-gray-600">{agent.performance?.callCount ?? 0}</td>
                  <td className="px-5 py-4 text-center">
                    {agent.performance?.avgScore != null ? (
                      <span className="font-semibold" style={{ color: getScoreColor(agent.performance.avgScore) }}>
                        {agent.performance.avgScore.toFixed(0)}
                      </span>
                    ) : (
                      <span className="text-gray-400">—</span>
                    )}
                  </td>
                  <td className="px-5 py-4 text-center text-gray-600">
                    {agent.performance?.tourRate != null ? `${agent.performance.tourRate.toFixed(0)}%` : '—'}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
